import { Pathname } from "./pathname";
import { convertRoutesToUseIdParams } from "../../utils/route-utils";

export const PathnameGenerator = (name: string) => {
  return Pathname.DASHBOARD_ACCOUNTING + name;
};

const PATHNAME_INVOICE = {
  PURCHASE_INVOICES: "/invoice/purchase-invoices",
  ADD_PURCHASE_INVOICE: "/invoice/purchase-invoices/add-purchase-invoice",
  EDIT_PURCHASE_INVOICE: "/invoice/purchase-invoices/:id/edit-purchase-invoice",
  VIEW_PURCHASE_INVOICE: "/invoice/purchase-invoices/:id/view-purchase-invoice",
  SALES_INVOICES: "/invoice/sales-invoices",
  ADD_SALES_INVOICES: "/invoice/sales-invoices/add-sales-invoice",
  EDIT_SALES_INVOICES: "/invoice/sales-invoices/:id/edit-sales-invoice",
  VIEW_SALES_INVOICES: "/invoice/sales-invoices/:id/view-sales-invoice",
  CASH_EXPENSES: "/invoice/cash-expenses",
  ADD_CASH_EXPENSE: "/invoice/cash-expenses/add-cash-expense",
  EDIT_CASH_EXPENSE: "/invoice/cash-expenses/:id/edit-cash-expense",
  VIEW_CASH_EXPENSE: "/invoice/cash-expenses/:id/view-cash-expense",
};

const PATHNAME_PAYMENT_ENTRY = {
  PAYMENT: "/payment-entry/payment",
  ADD_PAYMENT_ENTRY: "/payment-entry/payment/add-payment-entry",
  EDIT_PAYMENT_ENTRY: "/payment-entry/payment/:id/edit-payment-entry",
  VIEW_PAYMENT_ENTRY: "/payment-entry/payment/:id/view-payment-entry",
  COLLECTION: "/payment-entry/collection",
  ADD_COLLECTION_ENTRY: "/payment-entry/collection/add-collection-entry",
  EDIT_COLLECTION_ENTRY: "/payment-entry/collection/:id/edit-collection-entry",
  VIEW_COLLECTION_ENTRY: "/payment-entry/collection/:id/view-collection-entry",
};

const PATHNAME_EXPENSE_REIMBURSEMENT = {
  EXPENSE_REIMBURSEMENT: "/expense/expense-reimbursement",
  ADD_EXPENSE_REIMBURSEMENT: "/expense/expense-reimbursement/add-expense-reimbursement",
  EDIT_EXPENSE_REIMBURSEMENT: "/expense/expense-reimbursement/:id/edit-expense-reimbursement",
  VIEW_EXPENSE_REIMBURSEMENT: "/expense/expense-reimbursement/:id/view-expense-reimbursement",
  EXPENSE_REPORT: "/expense/expense-report",
  VIEW_EXPENSE_REPORT: "/expense/expense-report/:id/view-expense-report",
  ADD_EXPENSE_PAYEMENT: "/expense/payment/add-payment",
  EDIT_EXPENSE_PAYEMENT: "/expense/payment/:id/edit-expense-payment",
  VIEW_EXPENSE_PAYEMENT: "/expense/payment/:id/view-expense-payment",
  VIEW_EXPENSE_PAYEMENT_LIST: "/expense/payment/:id/expense-payment-list",
};

const PATHNAME_COMMISSIONS = {
  COMMISSION_PLAN: "/commissions/commission-plan",
  ADD_COMMISSION_PLAN: "/commissions/add-commission-plan",
  EDIT_COMMISSION_PLAN: "/commissions/:id/edit-commission-plan",
  VIEW_COMMISSION_PLAN: "/commissions/:id/view-commission-plan",
  COMMISSION_TARGET: "/commissions/target",
  ADD_COMMISSION_TARGET: "/commissions/add-commission-target",
  EDIT_COMMISSION_TARGET: "/commissions/:id/edit-commission-target",
  VIEW_COMMISSION_TARGET: "/commissions/:id/view-commission-target",
  COMMISSION_ASSIGNMENT: "/commissions/assignment",
  ADD_COMMISSION_ASSIGNMENT: "/commissions/add-commission-assignment",
  EDIT_COMMISSION_ASSIGNMENT: "/commissions/:id/edit-commission-assignment",
  VIEW_COMMISSION_ASSIGNMENT: "/commissions/:id/view-commission-assignment",
  AUTHORIZE_COMMISSION: "/commissions/authorize-commission",
  VIEW_AUTHORIZE_COMMISSION: "/commissions/:id/view-authorize-commission",
  EDIT_AUTHORIZE_COMMISSION: "/commissions/:id/edit-authorize-commission",
  COMMISSION: "/commissions/commission",
  VIEW_COMMISSION: "/commissions/:id/view-commission",
  EDIT_COMMISSION: "/commissions/:id/edit-commission",
  MONTH_WISE_COMMISSION: "/commissions/month-wise-commission",
  ADD_MONTH_WISE_COMMISSION: "/commissions/add-month-wise-commission",
  EDIT_MONTH_WISE_COMMISSION: "/commissions/:id/edit-month-wise-commission",
  VIEW_MONTH_WISE_COMMISSION: "/commissions/:id/view-month-wise-commission",
};

const PATHNAME_ASSETS = {
  ASSETS_MANAGEMENT: "/assets/assets-management",
  ADD_ASSET: "/assets/assets-management/add-asset",
  VIEW_ASSET: "/assets/assets-management/:id/view-asset",
  EDIT_ASSET: "/assets/assets-management/:id/edit-asset",
  MODIFY_DISPOSE: "/assets/assets-management/modify-dispose",
  ASSET_TRANSFER: "/assets/asset-transfer",
  ADD_ASSET_TRANSFER: "/assets/asset-transfer/add-asset-transfer",
  VIEW_ASSET_TRANSFER: "/assets/assets-transfer/:id/view-asset-transfer",
  EDIT_ASSET_TRANSFER: "/assets/assets-transfer/:id/edit-asset-transfer",
};

const PATHNAME_CREDIT = {
  DEBIT_NOTE: "/credits/debit-note",
  ADD_DEBIT_NOTE: "/credits/add-debit-note",
  EDIT_DEBIT_NOTE: "/credits/:id/edit-debit-note",
  VIEW_DEBIT_NOTE: "/credits/:id/view-debit-note",
  CREDIT_NOTE: "/credits/credit-note",
  ADD_CREDIT_NOTE: "/credits/add-credit-note",
  EDIT_CREDIT_NOTE: "/credits/:id/edit-credit-note",
  VIEW_CREDIT_NOTE: "/credits/:id/view-credit-note",
};

const PATHNAME_CUSTOMER_AND_VENDOR = {
  CUSTOMER_MANAGEMENT: "/master-data/customer-management",
  ADD_CUSTOMER_MANAGEMENT: "/master-data/customer-management/add-customer",
  EDIT_CUSTOMER_MANAGEMENT: "/master-data/customer-management/:id/edit-customer",
  VIEW_CUSTOMER_MANAGEMENT: "/master-data/customer-management/:id/view-customer",
  VENDOR_MANAGEMENT: "/master-data/vendor-management",
  ADD_VENDOR_MANAGEMENT: "/master-data/vendor-management/add-vendor",
  EDIT_VENDOR_MANAGEMENT: "/master-data/vendor-management/:id/edit-vendor",
  VIEW_VENDOR_MANAGEMENT: "/master-data/vendor-management/:id/view-vendor",
};

const PATHNAME_REPORTS = {
  BALANCE_SHEET: "/reports/balance-sheet",
  GENERAL_LEDGER: "/reports/general-ledger",
  CASHFLOW: "/reports/cashflow",
  PROFIT_AND_LOSS: "/reports/profit-and-loss",
  TAX_REPORT: "/reports/tax-report",
  TRIAL_BALANCE: "/reports/trial-balance",
  AGED_PAYABLE: "/reports/aged-payable",
  VAT_REPORT: "/reports/vat-report",
  VAT_DETAIL_ITEM: "/reports/vat-detail-item",
  AGED_RECEIVABLE: "/reports/aged-receivable",
  DEPRECIATION_SCHEDULE: "/reports/depreciation-schedule",
  JOURNAL_REPORT: "/reports/journal-report",
  SHAREHOLDER_REPORT: "/reports/shareholder-report",
  SCHEDULE_REPORT: "/reports/schedule-report",
  JOURNAL_ITEM: "/reports/journal-item",
  CUSTOMER_SOA: "/reports/soa/customer",
  VENDOR_SOA: "/reports/soa/vendor",
  COLLECTION_REGISTER: "/reports/collection-register",
};

const PATHNAME_SETTINGS = {
  CHART_OF_ACCOUNTS: "/settings/chart-of-accounts",
  VOUCHER_SETTINGS: "/settings/voucher-settings",
  ADD_VOUCHER_SETTING: "/settings/voucher-settings/add",
  EDIT_VOUCHER_SETTING: "/settings/voucher-settings/:id/edit",
  VIEW_VOUCHER_SETTING: "/settings/voucher-settings/:id/view",
  CURRENCY: "/settings/currency",
  ADD_CURRENCY: "/settings/currency/add-currency",
  EDIT_CURRENCY: "/settings/currency/:id/edit-currency",
  VIEW_CURRENCY: "/settings/currency/:id/view-currency",
  CURRENCY_EXCHANGE: "/settings/currency-exchange",
  TAX_CATEGORY: "/settings/tax-category",
  ADD_TAX_CATEGORY: "/settings/add-tax-category",
  EDIT_TAX_CATEGORY: "/settings/:id/edit-tax-category",
  VIEW_TAX_CATEGORY: "/settings/:id/view-tax-category",
  TAX_CODE: "/settings/tax-code",
  TAX_TEMPLATE: "/settings/tax-template",
  ADD_TAX_TEMPLATE: "/settings/add-tax-template",
  EDIT_TAX_TEMPLATE: "/settings/:id/edit-tax-template",
  VIEW_TAX_TEMPLATE: "/settings/:id/view-tax-template",
  BANK: "/settings/bank",
  BANK_ACCOUNT: "/settings/bank-account",
  ADD_BANK_ACCOUNT: "/settings/add-bank-account",
  EDIT_BANK_ACCOUNT: "/settings/:id/edit-bank-account",
  VIEW_BANK_ACCOUNT: "/settings/:id/view-bank-account",
  RECONCILIATION: "/settings/reconciliation",
  FISCAL_YEAR: "/settings/fiscal-year",
  ACCOUNT_PERIOD: "/settings/account-period",
  PAYMENT_TERMS: "/settings/payment-terms",
  ADD_CHART_OF_ACCOUNTS: "/settings/chart-of-accounts/add-chart-of-accounts",
  EDIT_CHART_OF_ACCOUNTS: "/settings/chart-of-accounts/:id/edit-chart-of-accounts",
  VIEW_CHART_OF_ACCOUNTS: "/settings/chart-of-accounts/:id/view-chart-of-accounts",
  ADD_CURRENCY_EXCHANGE: "/settings/currency-exchange/add-currency-exchange",
  EDIT_CURRENCY_EXCHANGE: "/settings/currency-exchange/:id/edit-currency-exchange",
  VIEW_CURRENCY_EXCHANGE: "/settings/currency-exchange/:id/view-currency-exchange",
  ADD_FISCAL_YEAR: "/settings/fiscal-year/add-fiscal-year",
  EDIT_FISCAL_YEAR: "/settings/fiscal-year/:id/edit-fiscal-year",
  VIEW_FISCAL_YEAR: "/settings/fiscal-year/:id/view-fiscal-year",
  ADD_TAX_CODE: "/settings/tax-code/add-tax-code",
  EDIT_TAX_CODE: "/settings/tax-code/:id/edit-tax-code",
  VIEW_TAX_CODE: "/settings/tax-code/:id/view-tax-code",
  ADD_PAYMENT_TERM: "/settings/payment-term/add-payment-term",
  EDIT_PAYMENT_TERM: "/settings/payment-term/:id/edit-payment-term",
  VIEW_PAYMENT_TERM: "/settings/payment-term/:id/view-payment-term",
  ADD_BANK: "/settings/bank/add-bank",
  EDIT_BANK: "/settings/bank/:id/edit-bank",
  VIEW_BANK: "/settings/bank/:id/view-bank",
  JOURNAL_TYPES: "/settings/journal-types",
  ADD_JOURNAL_TYPE: "/settings/journal-types/add-journal-type",
  EDIT_JOURNAL_TYPE: "/settings/journal-types/:id/edit-journal-type",
  VIEW_JOURNAL_TYPE: "/settings/journal-types/:id/view-journal-type",
  ADD_RECONCILIATION: "/settings/reconciliation/add-reconciliation",
  EDIT_RECONCILIATION: "/settings/reconciliation/:id/edit-reconciliation",
  VIEW_RECONCILIATION: "/settings/reconciliation/:id/view-reconciliation",
  FORMS: "/settings/forms",
  CUSTOM_FORM: "/settings/custom-form",
};

const PATHNAME_PAYMENT_REQUEST = {
  ADD_PAYMENT_REQUEST: "/payment-request/add-payment-request",
  VIEW_PAYMENT_REQUEST: "/payment-request/:id/view-payment-request",
};

export const PathnameAccounting = {
  LANDING_PAGE: "/",
  LIST: "/list",
  JOURNAL_ENTRY: "/journal-entry",
  ADD_JOURNAL_ENTRY: "/journal-entry/add-journal-entry",
  EDIT_JOURNAL_ENTRY: "/journal-entry/:id/edit-journal-entry",
  VIEW_JOURNAL_ENTRY: "/journal-entry/:id",
  PAYMENT_ENTRY: "/payment-entry",
  ...PATHNAME_PAYMENT_ENTRY,
  PAYMENT_REQUEST: "/payment-request",
  ...PATHNAME_PAYMENT_REQUEST,
  INVOICE: "/invoice",
  ...PATHNAME_INVOICE,
  CREDITS: "/credits",
  ...PATHNAME_CREDIT,
  EXPENSE: "/expense",
  ...PATHNAME_EXPENSE_REIMBURSEMENT,
  COMMISSIONS: "/commissions",
  ...PATHNAME_COMMISSIONS,
  ASSETS: "/assets",
  ...PATHNAME_ASSETS,
  BUDGET: "/budget",
  ADD_BUDGET: "/budget/add-budget",
  EDIT_BUDGET: "/budget/:id/edit-budget",
  VIEW_BUDGET: "/budget/:id/view-budget",
  COMPARE_BUDGET: "/budget/compare-budget",
  AUDITS: "/audits",
  CUSTOMER_AND_VENDOR_MASTER_DATA: "/master-data",
  ...PATHNAME_CUSTOMER_AND_VENDOR,
  REPORTS: "/reports",
  ...PATHNAME_REPORTS,
  SETTINGS: "/settings",
  ...PATHNAME_SETTINGS,
};
